import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { isSiteAdminRole } from "../utils/roles";

export default function RequireAdmin({ children }) {
  const { user, role, profile, claimsReady, profileReady, loading } = useAuth();
  const location = useLocation();

  if (loading || !claimsReady || (user && !profileReady)) {
    return <div className="page-loading">جاري التحقق من الصلاحيات...</div>;
  }

  if (!user) {
    return <Navigate to="/admin" replace state={{ from: location }} />;
  }

  if (role === "CHALET_OWNER") {
    if (profile?.status === "disabled") {
      return <Navigate to="/admin" replace />;
    }
    return <Navigate to="/owner" replace />;
  }

  const claimOk = isSiteAdminRole(role);
  const profileOk = isSiteAdminRole(profile?.role);
  if (!claimOk || !profileOk || profile?.status === "disabled") {
    return (
      <div className="page-loading" style={{ padding: 24, textAlign: "center" }}>
        <p>حسابك مسجل لكن بدون صلاحية إدارة.</p>
        <p>البريد: {user.email}</p>
        <p>UID: {user.uid}</p>
      </div>
    );
  }

  return children;
}
